/**
 * 製造の「ロケーション」は 設定 → 場所（全社でひとつの場所マスタ）に統合された。
 * この画面は案内だけを出す（登録・変更は /settings/locations）。
 */
export default function Locations() {
  return (
    <div className="rounded-lg border border-zinc-200 bg-zinc-50 px-4 py-5"
      data-testid="mfg-locations-moved">
      <p className="text-sm font-semibold text-zinc-800">
        場所の登録・変更は 設定 → 場所 で行います
      </p>
      <p className="mt-1 text-xs text-zinc-600">
        倉庫・棚・ビンは、技術・製造・IT・備品で共通の「一つの場所マスタ」になりました。
        部署（SNS / SOL / HTR / 技術 / IT / 総務・共通）もそこで選びます。
      </p>
      <a href="/settings/locations"
        className="mt-3 inline-flex items-center rounded-md bg-teal-700 px-3 py-2 text-xs font-semibold text-white hover:bg-teal-800"
        data-testid="mfg-locations-link">
        設定 → 場所 を開く
      </a>
    </div>
  );
}
